import { ServiceContainer } from './ServiceContainer';
import { RoundsRepo } from '@/repos/RoundsRepo';
import { RoundService } from './RoundService';
import { LeaguesRepo } from '@/repos/LeaguesRepo';
import { LeagueService } from './LeagueService';
import { UsersRepo } from '@/repos/UsersRepo';
import { CoursesRepo } from '@/repos/CoursesRepo';
import { UserService } from './UserService';
import { CourseService } from './CourseService';
import { BackgroundSyncService } from '@/services/BackgroundSyncService';
import { JsonCacheRepo } from '@/repos/base/JsonCacheRepo';
import { StringCacheRepo } from '@/repos/base/StringCacheRepo';
import { UserDashboardService } from './UserDashboardService';
import { UserDashboardsRepo } from '@/repos/UserDashboardsRepo';
import { CacheRepo } from '@/repos/base/CacheRepo';
import { LeagueMembershipService } from './LeagueMembershipService';
import { LeagueMembershipsRepo } from '@/repos/LeagueMembershipsRepo';
import { LeagueResultsRepo } from '@/repos/LeagueResultsRepo';
import { LeagueResultService } from './LeagueResultService';
import { LeagueAdminService } from './LeagueAdminService';

export function initializeServices() {
    const container = ServiceContainer.getInstance();

    // Initialize repositories
    const roundsRepo = new RoundsRepo();
    const leaguesRepo = new LeaguesRepo();
    const usersRepo = new UsersRepo();
    const coursesRepo = new CoursesRepo();
    const userDashboardsRepo = new UserDashboardsRepo();
    const leagueMembershipsRepo = new LeagueMembershipsRepo();
    const leagueResultsRepo = new LeagueResultsRepo();

    // Register repositories as singletons (they maintain state and should be shared)
    container.registerSingleton(RoundsRepo, roundsRepo);
    container.registerSingleton(LeaguesRepo, leaguesRepo);
    container.registerSingleton(UsersRepo, usersRepo);
    container.registerSingleton(CoursesRepo, coursesRepo);
    container.registerSingleton(UserDashboardsRepo, userDashboardsRepo);
    container.registerSingleton(LeagueMembershipsRepo, leagueMembershipsRepo);
    container.registerSingleton(CacheRepo, new CacheRepo<string>());
    container.registerSingleton(LeagueResultsRepo, leagueResultsRepo);

    // Register services with different scoping strategies
    // RoundService as singleton (shared instance)
    const courseService = new CourseService(coursesRepo);
    const userService = new UserService(usersRepo);
    const userDashboardService = new UserDashboardService(userDashboardsRepo, courseService);
    const roundService = new RoundService(roundsRepo, userDashboardService);
    const leagueService = new LeagueService(leaguesRepo);
    const leagueMembershipService = new LeagueMembershipService(leagueMembershipsRepo);
    const leagueResultService = new LeagueResultService(leagueResultsRepo);
    const leagueAdminService = new LeagueAdminService();
    const backgroundSyncService = new BackgroundSyncService(roundService);

    container.registerSingleton(RoundService, roundService);
    container.registerSingleton(BackgroundSyncService, backgroundSyncService);
    container.registerSingleton(UserDashboardService, userDashboardService);

    container.registerSingleton(LeagueService, leagueService);
    container.registerSingleton(LeagueMembershipService, leagueMembershipService);
    container.registerSingleton(LeagueResultService, leagueResultService);
    container.registerSingleton(LeagueAdminService, leagueAdminService);
    container.registerSingleton(UserService, userService);
    container.registerSingleton(CourseService, courseService);
    container.registerSingleton(JsonCacheRepo, new JsonCacheRepo());
    container.registerSingleton(StringCacheRepo, new StringCacheRepo());



    // LeagueService as transient (new instance per request)
    // container.registerTransient('leagueService', () => new LeagueService(leaguesRepo));



    return container;
} 